import { type GravatarWithNameProps } from "./component";

export const getInitials = (props: Partial<GravatarWithNameProps>): string => {
  let firstName = props.firstName ?? "";
  let lastName = props.lastName ?? "";
  if (props.displayName) {
    const parts = props.displayName.split(" ");
    firstName = parts[0] ?? "";
    lastName = parts[1] ?? "";
  }

  return `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase();
};
